import React, { useEffect, useRef, useState } from 'react'

// COMPONENTS
import FullPageLoader from '../components/Layout/FullPageLoader'
import FilterBar from '../components/salesPerformance/FilterBar'
import CompletedSalesTable from '../components/salesPerformance/CompletedSalesTable'
import CommissionListingTable from '../components/salesPerformance/CommissionListingTable'
import CommissionListingAgentTable from '../components/salesPerformance/CommissionListingAgentTable'

// DUMMY DATA
import CompletedSalesByBranch from '../components/salesPerformance/dummy/CompletedSalesByBranch.json'
import CompletedSalesByGroup from '../components/salesPerformance/dummy/CompletedSalesByGroup.json'
import AgentCompletedSalesByDate from '../components/salesPerformance/dummy/AgentCompletedSalesByDate.json'
import CompletedSalesCommissionByUserID from '../components/salesPerformance/dummy/CompletedSalesCommissionByUserID.json'

const SalesPerformance = () => {
  const tableContainer = useRef(null)

  const [loading, setLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [commissionType, setCommissionType] = useState(null)
  const [listedBy, setListedBy] = useState('Branch')

  // SELECTED FOR DATA TYPE
  const [selectedCompletedSales, setSelectedCompletedSales] = useState(null)
  const [selectedAgent, setSelectedAgent] = useState(null)

  // DATA FOR TABLE
  const [completedSalesByBranchGroupData, setCompletedSalesByBranchGroupData] = useState(null)
  const [agentCompletedSalesByDateData, setAgentCompletedSalesByDateData] = useState(null)
  const [completedSalesCommissionByUserIDData, setCompletedSalesCommissionByUserIDData] = useState(null)

  const handleFilter = (data) => {
    const filterData = { ...data }
    filterData.startDate = data.startDate.toISOString()
    filterData.endDate = data.endDate.toISOString()

    setListedBy(filterData.listedBy)
    setCompletedSalesByBranchGroupData(null)
    setAgentCompletedSalesByDateData(null)
    setCompletedSalesCommissionByUserIDData(null)
    setSelectedCompletedSales(null)

    // DO THE FILTERING WITH THE filterData
    setFilterData(filterData)
    setIsFetching(!isFetching)
  }

  const handleSelectCompletedSales = item => {
    setSelectedCompletedSales(item)
    setSelectedAgent(null)

    // FETCH DATA FOR TABLE BASED ON SELECTED BRANCH OR GROUP
    // ../api/getAgentCompletedSalesByDate
    setAgentCompletedSalesByDateData(AgentCompletedSalesByDate)
  }

  const handleSelectAgent = (agent, column) => {
    setSelectedAgent(agent)
    setCommissionType(column)

    // FETCH DATA FOR TABLE BASED ON SELECTED AGENT AND COLUMN
    // ../api/getCompletedSalesCommissionByUserID
    setCompletedSalesCommissionByUserIDData(CompletedSalesCommissionByUserID)
  }

  useEffect(() => {
    if (filterData) {
      setLoading(true)

      // ../api/getCompletedSalesByBranchGroup
      if (filterData.listedBy === 'Branch') {
        setCompletedSalesByBranchGroupData(CompletedSalesByBranch)
        setLoading(false)
      } else if (filterData.listedBy === 'Group') {
        setCompletedSalesByBranchGroupData(CompletedSalesByGroup)
        setLoading(false)
      }
    }
  }, [isFetching])

  useEffect(() => {
    if (agentCompletedSalesByDateData || completedSalesCommissionByUserIDData) {
      tableContainer.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }, [agentCompletedSalesByDateData, completedSalesCommissionByUserIDData])

  return (
    <div className='w-screen h-screen bg-secondary-light flex flex-col'>
      <div className="w-full py-3.5 px-4 bg-primary text-white flex justify-between items-center relative">
        <p>Sales Performance Report</p>
      </div>

      <FilterBar
        onHandleFilter={ handleFilter }
      />
      
      <div className='flex-1 w-full relative'>
        <div className='absolute top-0 left-0 w-full h-full overflow-auto hide-scrollbar md:p-5 p-3'>
          <div className='w-full h-full flex flex-col'>
            <FullPageLoader loading={ loading } />

            <div ref={ tableContainer } className='flex flex-col md:gap-4 gap-2 pb-2 md:pb-4'>

              {
                completedSalesByBranchGroupData &&
                <div className='flex flex-col h-full w-full'>
                  <CompletedSalesTable
                    data={ completedSalesByBranchGroupData }
                    listedBy={ listedBy }
                    onSelect={ handleSelectCompletedSales }
                  />
                </div>
              }
              
              {
                agentCompletedSalesByDateData &&
                <div className='flex flex-col h-full w-full'>
                  <CommissionListingTable
                    data={ agentCompletedSalesByDateData }
                    selected={ selectedCompletedSales }
                    onSelect={ handleSelectAgent }
                  />
                </div>
              }

              {
                completedSalesCommissionByUserIDData &&
                <div className='flex flex-col h-full w-full'>
                  <CommissionListingAgentTable
                    data={ completedSalesCommissionByUserIDData }
                    selected={ selectedAgent }
                    commissionType={ commissionType }
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SalesPerformance